import React from 'react';

export default function OpenBetaTag() {
  return (
    <div className="text-blue-800 text-center text-xs font-medium justify-center items-center bg-blue-100 max-w-full px-2.5 py-0.5 rounded-xl">
      Open beta
    </div>
  );
}
